export function setCoverDetails(state, action) {
  let selectedPolicy = null;
  let policyDetails = null;

  if (state.policyDetails) {
    policyDetails = Object.assign({}, state.policyDetails, {
      Policies:
        state.policyDetails &&
        state.policyDetails.Policies &&
        state.policyDetails.Policies.map((policy) => {
          if (policy.MembershipNumber === action.payload.MembershipNumber) {
            let newPolicy = Object.assign(
              {},
              policy,
              {
                Members: policy.Members.map((member) => {
                  if (
                    (action.payload.SecurityId &&
                      member.SecurityId === action.payload.SecurityId) ||
                    (!action.payload.SecurityId && member.IsLoggedInMember)
                  ) {
                    return Object.assign({}, member, {
                      PlanDates: action.payload.PlanDates,
                      BenefitSummaryYears: action.payload.BenefitSummaryYear,
                      IsDoubleExcess:
                        action.payload.IsDoubleExcessWarningPeriod,
                      HasSixWeeksBenefit: action.payload.HasSixWeeksBenefit,
                      HasGuidedOptionBenefit:
                        action.payload.HasGuidedOptionBenefit
                    });
                  }
                  return member;
                })
              },
              action.payload.Members && action.payload.Members.length > 0
                ? { coverMembersList: action.payload.Members }
                : undefined
            );
            selectedPolicy = newPolicy;
            return newPolicy;
          }
          return policy;
        })
    });
  }

  return {
    policyDetails,
    selectedPolicy
  };
}
